import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { moduleName } from './constants'
import { ICommunityInfoState, ICommunityInfo } from './types'
import { AppThunk } from '../../type'
import { getCommunityInfo as fetchCommunityInfoAPI } from 'features/MyCommunity/api'
import { AxiosResponse } from 'axios'

const initialState: ICommunityInfoState = {
  communityInfo: {
    name: '',
    description: '',
    contact_person: {
      avatar_logo: null,
      first_name: '',
      last_name: '',
      role: '',
      uuid: ''
    }
  },
  isCommunityInfoLoading: false,
  isCommunityInfoLoaded: false,
  error: null
}

const CommunityInfoSlice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    getCommunityInfoStart(state: ICommunityInfoState) {
      state.isCommunityInfoLoading = true
      state.error = null
    },
    getCommunityInfoFinish(state: ICommunityInfoState) {
      state.isCommunityInfoLoading = false
      state.isCommunityInfoLoaded = true
    },
    setCommunityInfoError(
      state: ICommunityInfoState,
      action: PayloadAction<{ error: string }>
    ) {
      const { error } = action.payload
      state.error = error
    },
    setCommunityInfoAction(
      state: ICommunityInfoState,
      action: PayloadAction<{ communityInfo: ICommunityInfo }>
    ) {
      const { communityInfo } = action.payload
      state.communityInfo = communityInfo
    },
    resetCommunityInfoAction(state: ICommunityInfoState) {
      Object.keys(initialState).forEach(
        (key) =>
          ((state[key] as ICommunityInfoState[typeof key]) = initialState[key])
      )
    }
  }
})

export default CommunityInfoSlice.reducer
export const {
  getCommunityInfoStart,
  setCommunityInfoError,
  getCommunityInfoFinish,
  setCommunityInfoAction,
  resetCommunityInfoAction
} = CommunityInfoSlice.actions

export const fetchCommunityInfo =
  (community: string, completedCallback?: Function): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getCommunityInfoStart())
      const result = await fetchCommunityInfoAPI(community)
      if (result) {
        dispatch(
          setCommunityInfoAction({
            communityInfo: result.data as ICommunityInfo
          })
        )
        if (completedCallback) {
          completedCallback(result.data)
        }
      }
    } catch (e) {
      const err = e as AxiosResponse
      dispatch(setCommunityInfoError({ error: err?.data?.message as string }))
    } finally {
      dispatch(getCommunityInfoFinish())
    }
  }
